import {EventBus} from "../../../../common/ts/events/EventBus";
import {PageWithDfpRightBlockScrolledEvent} from "./events";
import {WhitelabelEvent} from "../../../../common/ts/events/Events";
import dom from "../../../../common/ts/core/dom";
import {SECOND_DFP_SELECTOR} from "./constants";

const FIXED_AD_CLASSNAME = 'dfpBannerRightFixed';

let eventBus: EventBus;

export function pageWithDfpRightBlockScrolledEventHandler(event: WhitelabelEvent) {
    const {
        payload: {
            topSiblingElement,
            topSiblingSpacing,
            secondDfpBottom,
            secondDfpSpacing,
            topBoundaryElementBottom,
            bottomBoundaryElementBottom,
            windowHeight,
            navbarElementHeight ,
        }
    } = (event as PageWithDfpRightBlockScrolledEvent);

    const topBoundaryElementBottomWithSpacing = topBoundaryElementBottom + topSiblingSpacing;

    const firstDfpIsNotVisible = topSiblingElement <= topBoundaryElementBottomWithSpacing;
    const secondDfpShouldBeFullyVisible = bottomBoundaryElementBottom <= secondDfpBottom
        || firstDfpIsNotVisible;

    if (secondDfpShouldBeFullyVisible) {
        if (firstDfpIsNotVisible) {
            eventBus.emit(new dom.AddClassEvent({selector: SECOND_DFP_SELECTOR, className: FIXED_AD_CLASSNAME}))
            eventBus.emit(new dom.AddStylesEvent({
                    selector: SECOND_DFP_SELECTOR,
                    styles: {top: `${topBoundaryElementBottomWithSpacing}px`, bottom: 'unset'}
                }
            ))
        }

        const spaceBetweenSecondDfpAndFooter = bottomBoundaryElementBottom + (bottomBoundaryElementBottom - secondDfpBottom) + secondDfpSpacing;
        const secondDfpHasReachFooter = spaceBetweenSecondDfpAndFooter < windowHeight;
        if (secondDfpHasReachFooter) {
            eventBus.emit(new dom.AddStylesEvent({
                    selector: SECOND_DFP_SELECTOR,
                    styles: {top: `${navbarElementHeight}px`, bottom: `${windowHeight - bottomBoundaryElementBottom}px`}
                }
            ))
        }
    } else {
        eventBus.emit(new dom.RemoveClassEvent({selector: SECOND_DFP_SELECTOR, className: FIXED_AD_CLASSNAME}));
    }
}

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(PageWithDfpRightBlockScrolledEvent.TYPE, pageWithDfpRightBlockScrolledEventHandler);
}

export default {
    init
};